/** @format */

import React, { useEffect } from "react";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import { uid } from "uid";
import { getNews, getNewsDetails } from "../services/AnimeService";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Loading from "../common/LoadingScreens/Loading";
import { Helmet } from "react-helmet";
import ReactHtmlParser from "react-html-parser";
import GoogleAd from "../ad/GoogleAd";
import { getFirstHalf } from "../common/helpers/arrayHelpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
// import { ArrowRightIcon } from "@heroicons/react/solid";

export default function ViewNewsScreen(props) {
	dayjs.extend(relativeTime);
	const [news, setNews] = React.useState({});
	const [newsList, setNewsList] = React.useState([]);
	const [filtered, setFiltered] = React.useState([]);

	const resolver = async () => {
		try {
			const res = await getNewsDetails(props.match.params.id);
			const list = await getNews();
			setNewsList(list.data);
			if (!res.status === 200) {
				toast("No anime news found");
				return props.history.push("/");
			}
			setNews(res.data);
			setFiltered(getFirstHalf(res.data.description));
		} catch (ex) {
			toast.error("Something Went Wrong");

			console.log(ex);
		}
	};

	useEffect(() => {
		resolver();
		//scrolling to top
		window.scrollTo(0, 0);
		//depending on the url id
		//eslint-disable-next-line
	}, [props.match.params.id]);
	if (Object.keys(news).length === 0 && news.constructor === Object)
		return <Loading />;

	return (
		<div className="dark:bg-gray-900">
			<Navbar />
			<Helmet>
				<title>{news.title}</title>
			</Helmet>
			<br />
			<div className="relative min-h-screen w-full rounded-lg ">
				<div className=" grid w-full container m-auto grid-flow-col gap-2 grid-cols-10">
					<div className="col-start-1 col-span-10 lg:col-span-7">
						<RenderNewsHeader news={news} filtered={filtered} />
					</div>
					<div className=" hidden lg:block lg:w-full  lg:col-span-3  ">
						<div className="w-full p-2  shadow h-[90vh]  overflow-scroll custom-scroll    sticky top-20 dark:bg-dark-800  bg-white rounded-xl">
							<RenderTrendingPosts newsList={newsList} />
							<div>
								<br />
								<GoogleAd slot="3827501817" />
							</div>
						</div>
					</div>{" "}
					{/* End of grid */}
				</div>
				<div className=" lg:hidden block w-full ">
					<div className="w-full p-2  shadow h-[90vh]  overflow-scroll custom-scroll    sticky top-20 dark:bg-dark-800  bg-white rounded-xl">
						<RenderTrendingPosts newsList={newsList} />

						<div>
							<br />
							<GoogleAd slot="3827501817" />
						</div>
					</div>
				</div>{" "}
			</div>
			<Footer />
		</div>
	);
}

function RenderTrendingPosts({ newsList }) {
	return (
		<>
			<div className="flex flex-row flex-wrap w-full overflow-hidden">
				<p className="dark:text-white  font-montserrat text-lg text-black">
					Trending Post{" "}
				</p>
			</div>
			{newsList.map((news) => {
				return (
					<Link
						target="_blank"
						to={`/view/news/${news.id}?title=${news.title}`}
						key={news.id}
					>
						<div className="mt-5   flex flex-wrap flex-col">
							<div className="shadow-md p-2">
								<hr />
								<img
									className="w-36 h-36 object-cover float-right rounded-lg ml-2"
									src={news.cover_image}
									alt="Post5"
								/>
								<p className="font-ubuntu dark:text-white">{news.title}</p>
								<p className="font-simonetta dark:text-white  text-right ">
									{news.author}
								</p>
								<p className=" dark:text-white text-[9px] text-right ">
									{news.created_at && dayjs(news.created_at).fromNow()}
								</p>
							</div>
						</div>
					</Link>
				);
			})}
		</>
	);
}

function RenderNewsHeader(props) {
	const { news, filtered } = props;
	let history = useHistory();
	return (
		<div className=" col-span-10  rounded-lg overflow-hidden  mt-16">
			{/* Header */}
			<header>
				<div className="flex  relative flex-row gap-5 px-3">
					<ArrowLeftIcon
						onClick={() => history.goBack()}
						className="w-8 cursor-pointer dark:text-white h-8 mt-1 "
					/>
					<p className="dark:text-white text-4xl  font-montserrat font-thin ">
						{news.title}
					</p>
				</div>
				<div className="ml-16 mt-3 text-sm  font-montserrat">
					<p className=" dark:text-white   font-thin ">
						By &nbsp; {news.author}
						<span>
							&nbsp;&nbsp;
							{news.created_at && dayjs(news.created_at).fromNow()}
						</span>
					</p>
				</div>
			</header>

			<div className="mt-5 flex flex-wrap flex-row gap-5 py-5 p-2 ">
				<RenderNews key={uid()} filtered={filtered} data={news} />
			</div>
		</div>
	);
}
function RenderNews(props) {
	const { description, slug, tags, cover_image } = props.data;
	//will render 500 characters  by default
	const [lines, setLines] = React.useState(450);

	//a function to truncate blog-post description
	// eslint-disable-next-line no-unused-vars
	const truncate = (str, n) => {
		// truncating the html without breaking the tags
		//its just a work around for now

		let toLong = str.split(" ").length > n;
		return toLong ? str.split(" ").slice(0, n).join(" ") + "....." : str;
	};

	const handelShowMore = () => {
		if (lines.length >= description.split(" ").length)
			return toast.show("Yaay! You've read it all");
		setLines(lines + 250);
	};

	return (
		<div className="w-auto ">
			<GoogleAd slot="3624870570" />
			<div className=" p-2 ">
				<img
					src={cover_image}
					alt="slug"
					className="w-full h-96 lg:w-3/4 lg:h-[40vh] shadow-md  md:h-[40vh] object-cover  m-auto   rounded-2xl"
				/>
			</div>
			<GoogleAd slot="4817343371" />

			<div
				id="blog-post"
				className="blogger dark:text-white max-w-4xl lg:pr-36 xl:p-5 m-auto mt-5 font-montserrat text-lg leading-9 "
			>
				{ReactHtmlParser(description)}

				<div
					className="showMore m-auto btn bg-red-500 pointer "
					onClick={handelShowMore}
				>
					Show More
				</div>
			</div>

			<div className="mt-5 flex flex-wrap flex-row gap-5">
				{tags.map((tag) => (
					<div
						key={uid()}
						className="bg-blue-300 p-2 text-xs font-simonetta text-blue-600 rounded-3xl"
					>
						#{tag}
					</div>
				))}
			</div>

			<div className="mt-5 flex flex-wrap flex-row gap-5">
				<div className="bg-gray-300  p-1 text-xs font-simonetta text-gray-800 rounded">
					#{slug}
				</div>
			</div>
			<GoogleAd slot="2849655584" />
			{/* For user Details */}
		</div>
	);
}
